<template>
  <div class="avaliacao">
    <div class="header">
      <TheAvatar
        :img="avaliacao.img"
        max-width="62px"
      />

      <div class="text">
        <p>
          {{ avaliacao.name }}
        </p>

        <div class="rating">
          <img src="@/assets/cards/star.svg">
          <img src="@/assets/cards/star.svg">
          <img src="@/assets/cards/star.svg">
          <img src="@/assets/cards/star.svg">
          <img src="@/assets/cards/star.svg">
        </div>

        <span>
          {{ avaliacao.date }}
        </span>
      </div>
    </div>
    <p class="comment">
      {{ avaliacao.comment }}
    </p>
  </div>
</template>

<script>
import TheAvatar from '@/components/Layout/TheAvatar'

export default {
    name: "Avaliacao",
    components: {
      TheAvatar
    },
    props: ['avaliacao']
}
</script>

<style scoped lang="scss">
.avaliacao {
    max-width: 348px;
    padding: 30px;

    .header {
        display: flex;

        .text {
            padding: 0 14px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            p {
                font-weight: 700;
                color: #3a3b3f;
                font-size: 1rem;
            }

            .rating {
                display: flex;
            }

            span {
                font-weight: 500;
                color: #777777;
                font-size: 0.875rem;
            }
        }
    }

    .comment {
        color: #777;
        font-size: 0.875rem;
        margin-top: 10px;
    }
}
</style>